/**
 * Choose the configured backend origin for a standalone frontend. A browser
 * page origin is only a safe fallback when the frontend and backend share a
 * host (for example, Django-served development mode).
 */
export function resolveApiHost(
  configuredApiHost: string | undefined,
  pageOrigin: string
) {
  return configuredApiHost?.trim() || pageOrigin;
}
